import { DictionaryHelper } from '@/helpers/dictionary.helper';
import { DictionaryCacheService } from '@/services/dictionary-cache.service';
import { Component, Input, OnInit } from '@angular/core';
import { AttributeGroup, PropertiesService, PropertyAttribute, PropertyCategory, RealProperty } from '@eemo/api-client';
import { PropertyAttributesFormComponent } from '../property-attributes-form/property-attributes-form.component';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-property-attributes-view',
    templateUrl: './property-attributes-view.component.html',
    styleUrls: ['./property-attributes-view.component.scss'],
    standalone: true,
    imports: [NgIf, NgFor, PropertyAttributesFormComponent]
})
export class PropertyAttributesViewComponent implements OnInit {
  @Input() prop: RealProperty;
  @Input() category: PropertyCategory;
  @Input() openInEditionGroupCode = 'CLASSIFICATION';

  loading = false;
  propValues: { [key: string]: PropertyAttribute } = {};
  groupsCode: string[] = [];
  groups: AttributeGroup[] = [];
  groupAttributeNumber: { [key: string]: number } = {};
  groupOpenedInEdition: { [key: string]: boolean } = {};

  constructor(
    private propService: PropertiesService,
    private dictCacheService: DictionaryCacheService,
    private dictHelper: DictionaryHelper
  ) {}

  ngOnInit() {
    this.loading = true;
    this.dictCacheService.getAttributesForCategory(this.category).forEach((attr) => {
      if (this.dictHelper.isAttrAvailableForProperty(attr, this.prop) && !this.groupsCode.includes(attr.groupCode)) {
        this.groupsCode.push(attr.groupCode);
        this.groups.push(this.dictCacheService.groups[attr.groupCode]);
        this.groupOpenedInEdition[attr.groupCode] = this.openInEditionGroupCode === attr.groupCode;
      }
    });

    this.groups.sort(DictionaryCacheService.sortAttr);
    this.propService.getRealPropertyAttributes(this.prop.uid, this.category).subscribe(
      (data) => {
        data.forEach((attrValue) => {
          this.propValues[attrValue.code] = attrValue;
        });
        this.loading = false;
      },
      (err) => {
        this.loading = false;
      }
    );
  }
}
